<mat-form-field subscriptSizing="dynamic" appearance="outline">
  <mat-label>{{ langSelected.value }}</mat-label>
  <mat-select [formControl]="langSelected">
    <mat-option [value]="'fr-FR'">FR</mat-option>
    <mat-option [value]="'en-US'">EN</mat-option>
  </mat-select>
</mat-form-field>
